import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';
import GallerySection from '../components/GallerySection';
import ContactForm from '../components/ContactForm';

export default function ServicePage({ serviceKey }) {
  // Service-specific data matching exact scrape texts and media
  const serviceData = {
    staalkonstruktioner: {
      title: 'Stålkonstruktioner på Sjælland | Gribskovsmeden ApS',
      metaDescription: 'Søger du efter skræddersyede stålkonstruktioner til byggeprojekter på Sjælland? Vi leverer holdbare løsninger i høj kvalitet. Kontakt os',
      pageHeading: 'Stålkonstruktioner',
      subtitle: 'Stålkonstruktioner på Sjælland',
      featuredImage: {
        src: 'https://assets.auxodev.dk/assets/a97cf6ea-7b79-4b87-946d-9f6d75bc924c/staalspaer-lejligheder-11024x576-2d10694eef-106-1000x563.jpg',
        alt: 'Stålkonstruktioner under opbygning på Sjælland'
      },
      gallerySlug: 'staalkonstruktioner',
      sections: [
        {
          heading: 'Funktionelle og holdbare stålkonstruktioner på Sjælland',
          paragraphs: [
            <>
              Stålkonstruktioner kan forbedre både funktionaliteten og æstetikken i en bygning, virksomhed eller hjem. Hos{' '}
              <Link to="/" className="text-amber-600 font-medium hover:underline">Gribskovsmeden ApS</Link>{' '}
              kan vi designe og bygge skræddersyede konstruktioner på Sjælland til ethvert formål.
            </>,
            'Eksempler på stålkonstruktioner, der kan forbedre en bygning eller virksomhed, er stålkonstruktioner til industriel brug, såsom lagerhaller, produktionsfaciliteter og varehuse. Disse konstruktioner kan øge opbevaringspladsen og forbedre effektiviteten i produktionsprocessen.',
            'Stålkonstruktioner kan også bruges i kommercielle bygninger, såsom kontorbygninger og butikscentre, for at skabe en moderne og industrielt udseende æstetik. Dette kan også forbedre funktionaliteten, da en stålkonstruktion kan bære tunge belastninger og give mere plads.',
            'Derudover kan konstruktioner af stål forbedre et hjem, eksempelvis som en del af en udvidelse eller tilføjelse. En stålkonstruktion kan give mere plads, skabe en moderne og stilfuld æstetik og øge ejendommens værdi.'
          ]
        },
        {
          heading: 'Stålkonstruktioner på Sjælland, der passer perfekt til din ejendoms stil og karakter',
          paragraphs: [
            <>
              Vi kan designe og producere skræddersyede stålkonstruktioner til en bred vifte af funktioner og formål, herunder{' '}
              <Link to="/trapper" className="text-amber-600 font-medium hover:underline">trapper</Link>,{' '}
              <Link to="/porte" className="text-amber-600 font-medium hover:underline">porte</Link>,{' '}
              <Link to="/hegn" className="text-amber-600 font-medium hover:underline">hegn</Link>,{' '}
              <Link to="/raekvaerk" className="text-amber-600 font-medium hover:underline">rækværk</Link>, tagkonstruktioner og meget mere. Uanset om du har brug for en stålkonstruktion til din bolig eller erhvervsejendom, kan vi levere den skræddersyede løsning, der passer perfekt til dine krav og behov.
            </>,
            'Vores stærke ekspertise inden for design og produktion af specialiserede stålkonstruktioner betyder, at vi kan skabe tilpassede løsninger til enhver industri og byggeri formål. Vores erfarne team af ingeniører og håndværkere arbejder tæt sammen for at sikre, at vores konstruktioner er bygget til den højeste kvalitet, uanset om de er til industrielle maskiner, bygninger eller andet.'
          ]
        },
        {
          heading: 'Hør mere om vores stålkonstruktioner',
          paragraphs: [
            <>
              <Link to="/kontakt" className="text-amber-600 font-medium hover:underline">Kontakt os</Link>{' '}
              i dag for at høre mere om vores skræddersyede stålkonstruktioner,{' '}
              <Link to="/raekvaerk" className="text-amber-600 font-medium hover:underline">rækværk</Link>{' '}
              samt andre tjenester. Du kan komme i kontakt med os på telefonnummer{' '}
              <a href="tel:61604241" className="font-semibold text-stone-900 hover:text-amber-600 whitespace-nowrap">(+45) 61 60 42 41</a>{' '}
              eller{' '}
              <a href="tel:48796816" className="font-semibold text-stone-900 hover:text-amber-600 whitespace-nowrap">(+45) 48 79 68 16</a>, eller send en e-mail til{' '}
              <a href="mailto:lars@gribskovsmeden.dk" className="font-semibold text-stone-900 hover:text-amber-600 whitespace-nowrap">lars@gribskovsmeden.dk</a>{' '}
              for at høre mere om vores. Vi er altid klar til at hjælpe dig med at skabe den perfekte stålkonstruktion til din ejendom på Sjælland.
            </>
          ]
        }
      ]
    },

    raekvaerk: {
      title: 'Rækværk på Sjælland | Gribskovsmeden ApS',
      metaDescription: 'Søger du efter elegante rækværk til dit projekt på Sjælland? Vi specialfremstiller rækværk. Kontakt os for professionel rådgivning',
      pageHeading: 'Rækværk',
      subtitle: 'Rækværk på Sjælland',
      featuredImage: {
        src: 'https://assets.auxodev.dk/assets/a97cf6ea-7b79-4b87-946d-9f6d75bc924c/raekvaerk-valby-station1024x768-0ae2c60169-150-1000x750.jpg',
        alt: 'Rækværk lavet af smed i Nordsjælland'
      },
      gallerySlug: 'raekvaerk',
      sections: [
        {
          heading: 'Skræddersyet rækværk på Sjælland – Kvalitet og design i fokus',
          paragraphs: [
            <>
              Hos <Link to="/" className="text-amber-600 font-medium hover:underline">Gribskovsmeden ApS</Link>{' '}
              tilbyder vi en bred vifte af forskellige typer af rækværk på Sjælland, der kan tilpasses til enhver ejendomstype. Vi forstår, at ejendomme har forskellige stilarter og karakteristika, og derfor har vi en bred vifte af rækværk i forskellige materialer og designs til rådighed.
            </>,
            'Vi kan levere alt fra klassiske træ- eller stålrækværk til mere moderne glasrækværk eller kabelrækværk. Vores team af erfarne håndværkere og designere kan hjælpe dig med at vælge den rette type af rækværk, der passer perfekt til din ejendom og dine personlige præferencer.',
            'Vi kan også tilpasse rækværket til at matche omgivelserne og stilen på din ejendom, såsom farver og materialevalg. Det er vigtigt for os at sikre, at vores rækværk er bygget til at være holdbare og funktionsdygtige, samtidig med at de matcher din ejendoms udseende og stil.'
          ]
        },
        {
          heading: 'Hvorfor vælge Gribskovsmeden ApS til dit næste rækværk på Sjælland?',
          paragraphs: [
            'Vi er ikke en masseproduktionsvirksomhed, og vores rækværk er ikke standardprodukter. Vi har en omfattende viden om forskellige materialer og designs og tager altid udgangspunkt i vores kunders ønsker og behov. Vi forstår, at det kan være svært at vælge det rigtige produkt til din ejendom, og derfor er vores erfarne håndværkere altid klar til at give dig råd og vejledning omkring forskellige muligheder og materialer.',
            'Vi leverer kun skræddersyede rækværksløsninger, der er designet til at passe perfekt til ejendommens arkitektur og omgivelser. Vi tror på, at et rækværk er mere end bare en sikkerhedsforanstaltning, og derfor har vi fokus på at levere løsninger, der er både æstetisk tiltalende og funktionelle.'
          ]
        },
        {
          heading: 'Kontakt os for skræddersyet rækværk',
          paragraphs: [
            'Hos Gribskovsmeden ApS er vi dedikerede til at levere langtidsholdbare rækværksløsninger af højeste kvalitet til vores kunder på Sjælland. Vi har særligt fokus på personlig kontakt og kvalitetssikring, og vores erfarne håndværkere arbejder tæt sammen med vores kunder for at skabe den perfekte løsning til deres ejendom.',
            <>
              <Link to="/kontakt" className="text-amber-600 font-medium hover:underline">Kontakt os</Link>{' '}
              på telefonnummer{' '}
              <a href="tel:61604241" className="font-semibold text-stone-900 hover:text-amber-600 whitespace-nowrap">(+45) 61 60 42 41</a>{' '}
              eller{' '}
              <a href="tel:48796816" className="font-semibold text-stone-900 hover:text-amber-600 whitespace-nowrap">(+45) 48 79 68 16</a>, eller send en e-mail til{' '}
              <a href="mailto:lars@gribskovsmeden.dk" className="font-semibold text-stone-900 hover:text-amber-600 whitespace-nowrap">lars@gribskovsmeden.dk</a>{' '}
              for at høre mere om vores rækværk,{' '}
              <Link to="/staalkonstruktioner" className="text-amber-600 font-medium hover:underline">stålkonstruktioner</Link>,{' '}
              <Link to="/trapper" className="text-amber-600 font-medium hover:underline">trapper</Link>{' '}
              eller andre tjenester. Vi ser frem til at høre fra dig.
            </>
          ]
        }
      ]
    },

    trapper: {
      title: 'Trapper på Sjælland | Gribskovsmeden ApS',
      metaDescription: 'Søger du efter specialdesignede trapper i stål, træ og glas på Sjælland? Vi leverer holdbare og æstetiske løsninger. Kontakt os',
      pageHeading: 'Trapper',
      subtitle: 'Trapper på Sjælland',
      featuredImage: {
        src: 'https://assets.auxodev.dk/assets/a97cf6ea-7b79-4b87-946d-9f6d75bc924c/haveje-trappe-og-vaern-7-330-1000x750.jpg',
        alt: 'Trapper på Sjælland'
      },
      gallerySlug: 'trapper',
      sections: [
        {
          heading: 'Indendørs og udendørs trapper på Sjælland – til boliger og erhvervsejendomme',
          paragraphs: [
            <>
              En trappe er en central del af enhver ejendom og spiller en afgørende rolle for ejendommens æstetik og funktionalitet. Det er derfor vigtigt at have en kvalitetstrappe, der både er funktionel, holdbar og sikker.{' '}
              <Link to="/" className="text-amber-600 font-medium hover:underline">Gribskovsmeden ApS</Link>{' '}
              udarbejder trapper på hele Sjælland.
            </>,
            'Gribskovsmeden ApS har mange års erfaring i at designe og bygge trapper, der er skræddersyet til kundens ønsker og behov. Vi ved, at det er vigtigt at have en trappe, der både er holdbar og funktionel, samtidig med at den passer til ejendommens stil og karakter.',
            'Vi kan skabe både indendørs og udendørs trapper er både holdbare og sikre, da vi aldrig går på kompromis med kvaliteten. Vi bruger kun de bedste materialer og sørger altid for at opfylde de strenge standarder, der er nødvendige for at skabe en holdbar og sikker trappe.',
            'Vi tilbyder en bred vifte af trappeløsninger, der kan tilpasses til enhver ejendomstype og stil. Vores erfarne team af håndværkere og designere kan hjælpe med at vælge den rette type af trappe, der passer perfekt til din ejendom og dine personlige præferencer.'
          ]
        },
        {
          heading: 'Kvalitetssikring og personlig kontakt',
          paragraphs: [
            'Hos Gribskovsmeden ApS lægger vi også stor vægt på personlig kontakt i vores arbejde. Vi lytter altid til vores kunders ønsker og krav, og arbejder tæt sammen med dem for at skabe den bedste trappeløsning til deres ejendom.',
            'Vores erfarne håndværkere er altid til rådighed for at besvare eventuelle spørgsmål og hjælpe med at finde den bedste løsning til enhver ejendomstype. Vi tror på at opbygge langvarige relationer med vores kunder og ser frem til at arbejde sammen med dig for at skabe den perfekte trappeløsning til din ejendom. Kontakt os i dag for at høre mere om vores trappeløsninger og tjenester.'
          ]
        },
        {
          heading: 'Professionelle trappeløsning',
          paragraphs: [
            'Har du brug for indendørs eller udendørs trapper? Vi leverer skræddersyede trappeløsninger til private og erhverv på Sjælland.',
            <>
              <Link to="/kontakt" className="text-amber-600 font-medium hover:underline">Kontakt os</Link>{' '}
              i dag på telefonnummer{' '}
              <a href="tel:61604241" className="font-semibold text-stone-900 hover:text-amber-600 whitespace-nowrap">(+45) 61 60 42 41</a>{' '}
              eller{' '}
              <a href="tel:48796816" className="font-semibold text-stone-900 hover:text-amber-600 whitespace-nowrap">(+45) 48 79 68 16</a>, eller send en e-mail til{' '}
              <a href="mailto:lars@gribskovsmeden.dk" className="font-semibold text-stone-900 hover:text-amber-600 whitespace-nowrap">lars@gribskovsmeden.dk</a>{' '}
              for at høre mere om vores trappeløsninger,{' '}
              <Link to="/raekvaerk" className="text-amber-600 font-medium hover:underline">rækværk</Link>,{' '}
              <Link to="/staalkonstruktioner" className="text-amber-600 font-medium hover:underline">stålkonstruktioner</Link>{' '}
              og andre tjenester. Vi ser frem til at arbejde sammen med dig for at skabe den perfekte trappeløsning til din ejendom.
            </>
          ]
        }
      ]
    },

    porte: {
      title: 'Porte på Sjælland | Gribskovsmeden ApS',
      metaDescription: 'Holdbare og stilfulde porte til private og erhverv på Sjælland. Vi tilbyder skræddersyede løsninger i høj kvalitet. Kontakt os i dag',
      pageHeading: 'Porte',
      subtitle: 'Porte på Sjælland',
      featuredImage: {
        src: 'https://assets.auxodev.dk/assets/a97cf6ea-7b79-4b87-946d-9f6d75bc924c/skydeport1024x768-eabe017ad6-154-1000x750.jpg',
        alt: 'Træport i Nordsjælland'
      },
      gallerySlug: 'porte',
      sections: [
        {
          heading: 'Skræddersyede og æstetiske porte på Sjælland til enhver ejendom',
          paragraphs: [
            <>
              Hos <Link to="/" className="text-amber-600 font-medium hover:underline">Gribskovsmeden ApS</Link>{' '}
              tilbyder vi et bredt udvalg af skræddersyede porte på Sjælland, der giver vores kunder mulighed for at skabe en port, der passer perfekt til deres ejendom. Vi forstår, at ejendomme har forskellige arkitektoniske stilarter og krav, og vi har derfor specialiseret os i at designe og fremstille porte i en lang række forskellige materialer og designs.
            </>,
            'En port kan have mange forskellige funktioner udover at være et simpelt adgangspunkt. Den kan også fungere som en æstetisk funktion, der forbedrer ejendommens udseende og karakter. Vores erfarne håndværkere tager højde for disse aspekter, når de designer og fremstiller portene.'
          ]
        },
        {
          heading: 'Kombiner forskellige materialer og designs',
          paragraphs: [
            'Vi kan levere både lukkede og luftige porte, afhængigt af kundens ønsker og krav. En lukket port kan give mere privatliv og sikkerhed, mens en luftig port kan være mere åben og indbydende. Vi kan også kombinere forskellige materialer og designs for at skabe en unik og personlig løsning, der matcher ejendommens stil og karakter.',
            'Vi forstår også vigtigheden af funktionalitet i portdesign. Vores portløsninger kan tilpasses forskellige åbnings- og lukningssystemer, afhængigt af kundens behov og ønsker.',
            'Uanset om du er på udkig efter en port til din bolig eller erhvervsejendom, kan vi levere den skræddersyede portløsning, der passer perfekt til dine krav og behov. Kontakt os i dag for at høre mere om vores portløsninger og tjenester. Vi er altid klar til at hjælpe dig med at skabe den perfekte portløsning til din ejendom.'
          ]
        },
        {
          heading: 'Hør mere om vores porte på Sjælland',
          paragraphs: [
            'Søger du efter porte på Sjælland? Vi leverer skræddersyede portløsninger til private og erhverv på Sjælland.',
            <>
              <Link to="/kontakt" className="text-amber-600 font-medium hover:underline">Kontakt os</Link>{' '}
              i dag på telefonnummer{' '}
              <a href="tel:61604241" className="font-semibold text-stone-900 hover:text-amber-600 whitespace-nowrap">(+45) 61 60 42 41</a>{' '}
              eller{' '}
              <a href="tel:48796816" className="font-semibold text-stone-900 hover:text-amber-600 whitespace-nowrap">(+45) 48 79 68 16</a>, eller send en e-mail til{' '}
              <a href="mailto:lars@gribskovsmeden.dk" className="font-semibold text-stone-900 hover:text-amber-600 whitespace-nowrap">lars@gribskovsmeden.dk</a>{' '}
              for at høre mere om vores portløsninger,{' '}
              <Link to="/trapper" className="text-amber-600 font-medium hover:underline">trapper</Link>{' '}
              og andre tjenester. Vi ser frem til at arbejde sammen med dig for at skabe den perfekte portløsning til din ejendom.
            </>
          ]
        }
      ]
    },

    hegn: {
      title: 'Hegn på Sjælland | Gribskovsmeden ApS',
      metaDescription: 'Leder du efter et solidt og stilfuldt hegn på Sjælland? Vi leverer hegn i høj kvalitet til en hver omgivelse. Få et uforpligtende tilbud nu',
      pageHeading: 'Hegn',
      subtitle: 'Hegn på Sjælland',
      featuredImage: {
        src: 'https://assets.auxodev.dk/assets/a97cf6ea-7b79-4b87-946d-9f6d75bc924c/hegn-vinkelvej800x600-afc2859fa0-94.jpg',
        alt: 'Hegn på Sjælland'
      },
      gallerySlug: 'hegn',
      sections: [
        {
          heading: 'Vi laver hegn på Sjælland i alle materialer og design',
          paragraphs: [
            'Skal du have lavet et nyt hegn på Sjælland? Vores hegn er ikke standardiserede, men derimod unikke og tilpasset kundens ønsker og den omkringliggende arkitektur. Vi lægger stor vægt på personlig kontakt og kvalitetssikring, hvilket betyder, at vores hegn altid er af højeste kvalitet.',
            'Vores erfarne og dedikerede håndværkere bruger kun de bedste materialer og maskiner til at designe og fremstille hegn til vores kunder. Vi kan tilbyde et bredt udvalg af materialer og designs, herunder træ, stål, jern og aluminium. Vi har også erfaring med at kombinere materialer for at opnå et unikt og skræddersyet look.',
            'Vi forstår vigtigheden af at vælge det rigtige hegn til din ejendom, og vores team står altid til rådighed for at give råd og vejledning omkring forskellige muligheder. Vi tager højde for den omkringliggende arkitektur og dine specifikke ønsker for at sikre, at dit valg passer perfekt til din ejendom og dets omgivelser.'
          ]
        },
        {
          heading: 'Hegn med fokus på kvalitet og holdbarhed',
          paragraphs: [
            'Vi er ikke en masseproduktionsvirksomhed, og vores hegn er ikke standardprodukter. Vi tror på, at hvert hegn skal være unikt og skræddersyet til hver enkelt kunde. Vi går aldrig på kompromis med kvaliteten af vores produkter, og vi garanterer derfor, at hegnet vil være af bedste holdbarhed.'
          ]
        },
        {
          heading: 'Kontakt os for at høre mere',
          paragraphs: [
            <>
              Hos <Link to="/" className="text-amber-600 font-medium hover:underline">Gribskovsmeden ApS</Link>{' '}
              tilbyder vi skræddersyede hegnløsninger til private og erhverv på Sjælland. Vi har særligt fokus på personlig kontakt og kvalitetssikring, hvilket betyder, at vi altid stræber efter at levere det bedste produkt til vores kunder. Vi tilbyder også skræddersyede{' '}
              <Link to="/porte" className="text-amber-600 font-medium hover:underline">porte</Link>{' '}
              og{' '}
              <Link to="/altan" className="text-amber-600 font-medium hover:underline">altaner</Link>.
            </>,
            <>
              <Link to="/kontakt" className="text-amber-600 font-medium hover:underline">Kontakt os</Link>{' '}
              i dag på telefonnummer{' '}
              <a href="tel:61604241" className="font-semibold text-stone-900 hover:text-amber-600 whitespace-nowrap">(+45) 61 60 42 41</a>{' '}
              eller{' '}
              <a href="tel:48796816" className="font-semibold text-stone-900 hover:text-amber-600 whitespace-nowrap">(+45) 48 79 68 16</a>, eller send en e-mail til{' '}
              <a href="mailto:lars@gribskovsmeden.dk" className="font-semibold text-stone-900 hover:text-amber-600 whitespace-nowrap">lars@gribskovsmeden.dk</a>{' '}
              for at høre mere om vores hegn og tjenester. Vi glæder os til at høre fra dig.
            </>
          ]
        }
      ]
    },

    altan: {
      title: 'Altan på Sjælland | Gribskovsmeden ApS',
      metaDescription: 'Få en skræddersyet altan på Sjælland! Vi designer, producerer og monterer altaner i høj kvalitet til private og erhverv. Kontakt os i dag',
      pageHeading: 'Altan',
      subtitle: 'Altan på Sjælland',
      featuredImage: {
        src: 'https://assets.auxodev.dk/assets/a97cf6ea-7b79-4b87-946d-9f6d75bc924c/altan-med-glas-11024x768-911f0a0581-58-1000x750.jpg',
        alt: 'Skræddersyet altan på Sjælland'
      },
      gallerySlug: 'altan',
      sections: [
        {
          heading: 'Få en skræddersyet altan på Sjælland – både til private og erhverv',
          paragraphs: [
            <>
              Skal vi stå for din altan? Hos{' '}
              <Link to="/" className="text-amber-600 font-medium hover:underline">Gribskovsmeden ApS</Link>{' '}
              tilbyder vi skræddersyede altaner på Sjælland til både private og erhvervskunder på hele Sjælland. Vi forstår, at hver kunde har unikke behov, og derfor tilbyder vi altaner, der er tilpasset det specifikke sted, hvor de skal bygges.
            </>,
            'Når det kommer til erhverv, er det vigtigt at kunne overholde en tidsplan med de andre i projektet samt levere et godt resultat, og det er netop, hvad vi tilbyder. Vi kan skræddersy en altan, der opfylder alle de krav og specifikationer, som din virksomhed har brug for.',
            'Hos Gribskovsmeden ApS er vi også specialiserede i at bygge altaner til private hjem. Vi forstår, at din altan er en forlængelse af dit hjem, og derfor er det vigtigt at have en altan, der passer til din stil og behov. Vi tager højde for omkringliggende arkitektur og skaber en altan, der passer perfekt til dit hjem og dit livsstil.'
          ]
        },
        {
          heading: 'Ingen standardiserede altaner – unik og tilpasset dine ønsker',
          paragraphs: [
            'Vi leverer alt det materiale og udstyr, der er nødvendigt for at bygge din drømmealtan. Vores produkter er skræddersyet til dine ønsker og behov. Der er ingen masseproduktion eller standardiserede altaner, fordi hver altan er unik og skabt til dig.',
            'Hos Gribskovsmeden ApS kan vi bygge altaner i alle materialer, der passer til dine ønsker og behov. Uanset om du ønsker en træ-, stål- eller glasaltan, har vi ekspertisen til at bygge den.'
          ]
        },
        {
          heading: 'Skal du have en ny altan på Sjælland?',
          paragraphs: [
            'Vi er stolte af at tilbyde personlig kontakt og kvalitetssikring på alle vores produkter. Hos Gribskovsmeden ApS er vi klar til at skabe den perfekte altan til dig.',
            <>
              <Link to="/kontakt" className="text-amber-600 font-medium hover:underline">Kontakt os</Link>{' '}
              i dag på telefonnummer{' '}
              <a href="tel:61604241" className="font-semibold text-stone-900 hover:text-amber-600 whitespace-nowrap">(+45) 61 60 42 41</a>{' '}
              eller{' '}
              <a href="tel:48796816" className="font-semibold text-stone-900 hover:text-amber-600 whitespace-nowrap">(+45) 48 79 68 16</a>, eller send en e-mail til{' '}
              <a href="mailto:lars@gribskovsmeden.dk" className="font-semibold text-stone-900 hover:text-amber-600 whitespace-nowrap">lars@gribskovsmeden.dk</a>, og lad os begynde på din drømmealtan på Sjælland. Vi tilbyder også skræddersyede{' '}
              <Link to="/porte" className="text-amber-600 font-medium hover:underline">porte</Link>{' '}
              og{' '}
              <Link to="/hegn" className="text-amber-600 font-medium hover:underline">hegn</Link>.
            </>
          ]
        }
      ]
    },

    'vi-tilbyder': {
      title: 'Vi tilbyder | Gribskovsmeden ApS',
      metaDescription: 'SMEDEARBEJDE Hos Gribskovsmeden ApS tilbyder vi ordreproducerede smedearbejde heriblandt aluminium og rustfrit stål. Vi producerer fortrinsvis til store og små virksomheder inden for nybyggeri og renovering. Vi arbejder hver dag målrettet på at levere kvalitetsarbejde til konkurrencedygtige priser, og bestræber os på at indfri kundernes forventninger. Vi bestræber os på at overholde aftalte betingelser og ... Læs Mere',
      pageHeading: 'Vi tilbyder',
      subtitle: 'SMEDEARBEJDE',
      featuredImage: {
        src: 'https://assets.auxodev.dk/assets/a97cf6ea-7b79-4b87-946d-9f6d75bc924c/altan-4-310.jpg',
        alt: 'Smedearbejde hos Gribskovsmeden ApS'
      },
      gallerySlug: 'alle',
      sections: [
        {
          heading: 'SMEDEARBEJDE',
          paragraphs: [
            <>
              Hos <Link to="/" className="text-amber-600 font-medium hover:underline">Gribskovsmeden ApS</Link>{' '}
              tilbyder vi ordreproducerede smedearbejde heriblandt aluminium og rustfrit stål. Vi producerer fortrinsvis til store og små virksomheder inden for nybyggeri og renovering.
            </>,
            'Vi arbejder hver dag målrettet på at levere kvalitetsarbejde til konkurrencedygtige priser, og bestræber os på at indfri kundernes forventninger. Vi bestræber os på at overholde aftalte betingelser og leveringstider.',
            'Vi har løsning til enhver opgave. Vi spænder vidt og kan tilpasse vores produkter, så det passer til netop vores kunders behov.',
            <>
              Ønsker du hjælp til din næste opgave, er du meget velkommen til at{' '}
              <Link to="/kontakt" className="text-amber-600 font-semibold underline hover:text-amber-700">kontakte os</Link>.
            </>
          ]
        },
        {
          heading: 'Tegning og opmåling',
          paragraphs: [
            <span className="font-bold text-stone-900 text-base" key="drawing">
              Gribskovsmeden tilbyder, at udfører opmålinger samt tegninger i 2D & 3D
            </span>
          ]
        }
      ]
    },

    ydelse: {
      title: 'Ydelse | Gribskovsmeden ApS',
      metaDescription: 'Har du brug for hjælp til denne type opgave? Så læs mere om, hvad vi kan tilbyde her.',
      pageHeading: 'Ydelse',
      subtitle: 'Ydelse',
      featuredImage: {
        src: 'https://assets.auxodev.dk/assets/a97cf6ea-7b79-4b87-946d-9f6d75bc924c/staalspaer-lejligheder-11024x576-2d10694eef-106-1000x563.jpg',
        alt: 'Ydelse hos Gribskovsmeden ApS'
      },
      gallerySlug: 'alle',
      sections: [
        {
          heading: 'Ydelse',
          paragraphs: [
            'Har du brug for hjælp til denne type opgave? Så læs mere om, hvad vi kan tilbyde her.',
            <>
              Kontakt os direkte på{' '}
              <a href="tel:+4548796816" className="font-semibold text-amber-600 hover:underline whitespace-nowrap">+45 48 79 68 16</a>{' '}
              eller{' '}
              <a href="mailto:lars@gribskovsmeden.dk" className="font-semibold text-amber-600 hover:underline whitespace-nowrap">lars@gribskovsmeden.dk</a>.
            </>
          ]
        }
      ]
    }
  };

  const data = serviceData[serviceKey] || serviceData.staalkonstruktioner;

  return (
    <>
      <SEOHead
        title={data.title}
        description={data.metaDescription}
        image={data.featuredImage?.src}
      />

      {/* Header Banner */}
      <div className="bg-stone-950 text-white py-14 md:py-20 relative overflow-hidden">
        <div className="absolute inset-0 z-0 opacity-45">
          {data.featuredImage && (
            <img
              src={data.featuredImage.src}
              alt=""
              className="w-full h-full object-cover object-center"
              style={{ objectFit: 'cover' }}
            />
          )}
          <div className="absolute inset-0 bg-gradient-to-r from-stone-950/85 via-stone-950/65 to-stone-950/40" />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <div className="flex items-center gap-2 text-xs text-amber-400 font-semibold uppercase tracking-wider mb-3">
              <Link to="/" className="hover:text-amber-300">Forside</Link>
              <span>/</span>
              <span>{data.pageHeading}</span>
            </div>

            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white">
              {data.pageHeading}
            </h1>

            {data.subtitle && (
              <p className="mt-3 text-lg sm:text-xl text-stone-300 font-medium">
                {data.subtitle}
              </p>
            )}

            <div className="mt-6 flex flex-wrap items-center gap-4 text-sm text-stone-300">
              <a
                href="tel:+4548796816"
                className="flex items-center gap-2 hover:text-white bg-stone-900/80 border border-stone-800 px-4 py-2 rounded-lg whitespace-nowrap"
              >
                <i className="fa-solid fa-phone text-amber-500" aria-hidden="true"></i>
                <span>+45 48 79 68 16</span>
              </a>
              <a
                href="mailto:lars@gribskovsmeden.dk"
                className="flex items-center gap-2 hover:text-white bg-stone-900/80 border border-stone-800 px-4 py-2 rounded-lg whitespace-nowrap"
              >
                <i className="fa-solid fa-envelope text-amber-500" aria-hidden="true"></i>
                <span>lars@gribskovsmeden.dk</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content Area */}
      <section className="py-14 md:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
            {/* Left Content Column */}
            <div className="lg:col-span-7 space-y-10">
              {data.sections.map((sec, idx) => (
                <div key={idx} className="space-y-4">
                  <h2 className="text-2xl sm:text-3xl font-bold text-stone-900 tracking-tight">
                    {sec.heading}
                  </h2>
                  <div className="space-y-4 text-stone-700 leading-relaxed text-base">
                    {sec.paragraphs.map((p, pIdx) => (
                      <p key={pIdx}>{p}</p>
                    ))}
                  </div>
                </div>
              ))}

              <div className="pt-6 border-t border-stone-200">
                <h3 className="text-lg font-bold text-stone-900 mb-3">
                  Udforsk også vores andre smedeydelser
                </h3>
                <div className="flex flex-wrap gap-2.5">
                  <Link to="/staalkonstruktioner" className="px-3.5 py-2 bg-stone-100 hover:bg-stone-200 text-stone-800 rounded-lg text-sm font-semibold transition-colors">
                    Stålkonstruktioner
                  </Link>
                  <Link to="/raekvaerk" className="px-3.5 py-2 bg-stone-100 hover:bg-stone-200 text-stone-800 rounded-lg text-sm font-semibold transition-colors">
                    Rækværk
                  </Link>
                  <Link to="/trapper" className="px-3.5 py-2 bg-stone-100 hover:bg-stone-200 text-stone-800 rounded-lg text-sm font-semibold transition-colors">
                    Trapper
                  </Link>
                  <Link to="/porte" className="px-3.5 py-2 bg-stone-100 hover:bg-stone-200 text-stone-800 rounded-lg text-sm font-semibold transition-colors">
                    Porte
                  </Link>
                  <Link to="/hegn" className="px-3.5 py-2 bg-stone-100 hover:bg-stone-200 text-stone-800 rounded-lg text-sm font-semibold transition-colors">
                    Hegn
                  </Link>
                  <Link to="/altan" className="px-3.5 py-2 bg-stone-100 hover:bg-stone-200 text-stone-800 rounded-lg text-sm font-semibold transition-colors">
                    Altan
                  </Link>
                </div>
              </div>
            </div>

            {/* Right Image & Contact Card Column */}
            <div className="lg:col-span-5 space-y-8">
              {data.featuredImage && (
                <div className="rounded-2xl overflow-hidden shadow-lg border border-stone-200/90 aspect-[4/3] bg-stone-900 group">
                  <img
                    src={data.featuredImage.src}
                    alt={data.featuredImage.alt}
                    className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-300 block"
                    style={{ objectFit: 'cover', width: '100%', height: '100%' }}
                  />
                </div>
              )}

              {/* Webform in Right Column */}
              <ContactForm />

              {/* Contact Card */}
              <div className="bg-stone-900 text-white rounded-2xl p-7 shadow-sm">
                <span className="text-xs uppercase font-bold text-amber-400 tracking-wider">
                  Få et uforpligtende tilbud
                </span>
                <h3 className="text-xl font-bold mt-1 text-white">
                  Kvalitetssikring og personlig kontakt
                </h3>
                <p className="text-stone-300 text-sm mt-3 leading-relaxed">
                  Hos Gribskovsmeden ApS tilbyder vi personlig kontakt og kvalitetssikring på alle vores produkter. Kontakt os i dag for at høre mere om dine muligheder.
                </p>

                <div className="mt-6 space-y-3 pt-4 border-t border-stone-800 text-sm">
                  <a href="tel:+4548796816" className="flex items-center gap-3 text-stone-200 hover:text-amber-400 transition-colors whitespace-nowrap">
                    <i className="fa-solid fa-phone text-amber-500 w-5" aria-hidden="true"></i>
                    <span className="font-semibold">+45 48 79 68 16</span>
                  </a>
                  <a href="tel:61604241" className="flex items-center gap-3 text-stone-200 hover:text-amber-400 transition-colors whitespace-nowrap">
                    <i className="fa-solid fa-mobile-screen text-amber-500 w-5" aria-hidden="true"></i>
                    <span>Mobil: (+45) 61 60 42 41</span>
                  </a>
                  <a href="mailto:lars@gribskovsmeden.dk" className="flex items-center gap-3 text-stone-200 hover:text-amber-400 transition-colors whitespace-nowrap">
                    <i className="fa-solid fa-envelope text-amber-500 w-5" aria-hidden="true"></i>
                    <span>lars@gribskovsmeden.dk</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Dynamic Gallery for this Service connected through CMS */}
      {data.gallerySlug && (
        <div className="bg-stone-50 border-t border-stone-200">
          <GallerySection
            targetSlug={data.gallerySlug}
            showFilter={false}
            title={`Galleri: ${data.pageHeading}`}
            subtitle={`Se eksempler på ${data.pageHeading.toLowerCase()} udført af Gribskovsmeden ApS`}
          />
        </div>
      )}
    </>
  );
}
